import { SvgIcon, SvgIconProps } from '@mui/material';

export default function TicketsIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 24 18" fill="none">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5 9C19.4991 7.16966 20.8194 5.60595 22.624 5.3C22.9853 5.23985 23.2501 4.92726 23.25 4.561V2.25C23.25 1.42157 22.5784 0.75 21.75 0.75H2.25C1.42157 0.75 0.75 1.42157 0.75 2.25V4.563C0.749918 4.92926 1.01472 5.24185 1.376 5.302C3.18479 5.60335 4.51056 7.16828 4.51056 9.002C4.51056 10.8357 3.18479 12.4006 1.376 12.702C1.01493 12.7625 0.750331 13.0749 0.75 13.441V15.75C0.75 16.5784 1.42157 17.25 2.25 17.25H21.75C22.5784 17.25 23.25 16.5784 23.25 15.75V13.437C23.2501 13.0707 22.9853 12.7581 22.624 12.698C20.8202 12.3922 19.5001 10.8296 19.5 9V9Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M12 6H17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.375 13.5C16.4105 13.5 17.25 12.6605 17.25 11.625C17.25 10.5895 16.4105 9.75 15.375 9.75C14.3395 9.75 13.5 10.5895 13.5 11.625C13.5 12.6605 14.3395 13.5 15.375 13.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 4.875C7.5 4.66789 7.66789 4.5 7.875 4.5C8.08211 4.5 8.25 4.66789 8.25 4.875C8.25 5.08211 8.08211 5.25 7.875 5.25C7.66789 5.25 7.5 5.08211 7.5 4.875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 9.375C7.5 9.16789 7.66789 9 7.875 9C8.08211 9 8.25 9.16789 8.25 9.375C8.25 9.58211 8.08211 9.75 7.875 9.75C7.66789 9.75 7.5 9.58211 7.5 9.375"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 13.875C7.5 13.6679 7.66789 13.5 7.875 13.5C8.08211 13.5 8.25 13.6679 8.25 13.875C8.25 14.0821 8.08211 14.25 7.875 14.25C7.66789 14.25 7.5 14.0821 7.5 13.875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
